import React from "react";
import { Input } from "./Input";

export const MultiTextInput = React.memo(({ label, name , values = [], placeholder=undefined, onChange, disabled, required, isReport }) => {

  placeholder = placeholder || label;
  const handleAddInput = () => {
    // Create a new array with added empty string
    const newInputs = [...values, ""];
    // Simulate an input event with array value
    const fakeEvent = {
      target: {
        name,
        value: newInputs
      }
    };
    onChange(fakeEvent);
  };

  const handleInputChange = (index, newValue) => {
    // Create a new array with updated value
    const newPartners = values.map((partner, i) =>
      i === index ? newValue : partner
    );
    // Simulate an input event with updated array
    const fakeEvent = {
      target: {
        name,
        value: newPartners
      }
    };
    onChange(fakeEvent);
  };

  if (isReport) {
    return (
      <ul>
        {values.map((value, index) => (
          <li key={index}>
            {label} {index + 1}: {value}
          </li>
        ))}
      </ul>
    );
  }

    return (
      <>
        <div className="form-group">
        <label className="partnerLabel">{label}{required && "*"}
          <button type="button" onClick={handleAddInput} disabled={disabled}>+</button>
        </label>
      </div>

      {(values.length > 0 ? values : []).map((value, index) => (
        <Input
          type="text"
          key={index}
          name={`${name}[${index}]`}
          placeholder={placeholder}
          value={value}
          onChange={(e) => handleInputChange(index, e.target.value)}
          disabled={disabled}
          required={required && index === 0}
          label={`${label} ${index + 1}`}
        />
      ))}
      </>
    );
  });
